import customerInactivity from '@/constants/customerInactivity';
import { app } from '@/main';
import { setScrollY } from './setScrollY';
import { isIos } from '@/utils/is-ios';

export function addOverlay(overlayId: string, duration = 200) {
  const overlayElement = document.createElement('div');

  overlayElement.id = overlayId;

  Object.assign(overlayElement.style, {
    width: '100%',
    height: '100%',
    position: 'fixed',
    display: 'block',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 28, 54, 0.3)',
    zIndex: app.$mobileCheck() ? 9999 : 999
  });

  if (!isIos() && !app.$mobileCheck()) {
    (function increment(value = 0) {
      overlayElement.style.opacity = String(value);

      if (overlayElement.style.opacity !== '1') {
        setTimeout(() => {
          increment(value + 0.1);
        }, duration / 10);
      }
    })();
  }

  document.body.append(overlayElement);

  setScrollY('.container-scrollable', 'hidden');
}

export function removeElement(elementId: string) {
  const overlayElement = document.getElementById(elementId);

  if (!overlayElement) return;

  overlayElement.remove();
  setScrollY('.container-scrollable', 'auto');
}

export function setCardScrollPosition(
  selector: string,
  overviewElementSelector: string
) {
  const cardEl = document.querySelector(selector);

  if (cardEl) {
    setTimeout(() => {
      if (isIos()) {
        addtHighlightCardOnIos(cardEl, overviewElementSelector);
      } else {
        cardEl.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest'
        });
      }
    }, 0);
  }
}

export function addtHighlightCardOnIos(
  cardEl: Element,
  overviewElementSelector: string
) {
  const tooltip = document.querySelector('.performance-item__mobile-tooltip');
  if (tooltip) document.body.appendChild(tooltip);

  const position = cardEl.getBoundingClientRect() as DOMRect;

  cardEl.setAttribute(
    'style',
    `
            position: fixed;
            z-index: 99999;
            left: 24px;
            background-color: white;
            top: ${position.top}px;
            width: ${position.width}px;
            height: ${position.height}px;
          `
  );

  document.body.appendChild(cardEl);

  const el = document.querySelector(overviewElementSelector);
  if (el) el.scrollTo({ left: position.x, behavior: 'smooth' });
}

export function removeHighlightEffectCard(
  selector: string,
  overviewElementSelector: string
) {
  const cardEl = document.querySelector(selector);
  if (cardEl) {
    cardEl.setAttribute(
      'style',
      `
            position: initial;
            z-index: 0;
            background-color: white;
          `
    );

    const el = document.querySelector(overviewElementSelector);
    if (el) el.appendChild(cardEl);
  }
}
